import React, { useState } from "react";
import {
  FaCheckCircle,
  FaTimesCircle,
  FaChevronDown,
  FaChevronUp,
} from "react-icons/fa";
import Button from "../../components/Button/Button";

const imageFields = [
  "profile_image",
  "father_profile_pic",
  "mother_profile_pic",
  "guardian_profile_pic",
];

// Safe value extractor
const safeValue = (val) => {
  if (val === undefined || val === null) return "";
  if (Array.isArray(val)) return safeValue(val[0]);
  return val;
};

// Check for valid image
const isValidImage = (val) => typeof val === "string" && val.trim() !== "";

const ParentRequestCard = ({
  item,
  selectedFields,
  toggleField,
  onApprove,
  onReject,
  defaultExpanded = false,
}) => {
  const fieldKeys = Object.keys(item.requested_data || {});
  const [isExpanded, setIsExpanded] = useState(defaultExpanded);
  const [comment, setComment] = useState(""); // New state for comment

  const isPending = item.status === "pending";

  return (
    <div className="card border-primary mb-2">
      {/* Header with expand/collapse */}
      <div
        className="card-header d-flex justify-content-between align-items-center cursor-pointer"
        onClick={() => setIsExpanded(!isExpanded)}
      >
        <div>
          <strong>
            {item.student?.first_name} {item.student?.last_name}
          </strong>{" "}
          | Admission: {item.student?.id_number || "—"} | Status:{" "}
          <span
            className={`badge ${
              isPending
                ? "bg-warning"
                : item.status === "approved"
                ? "bg-success"
                : "bg-danger"
            }`}
          >
            {item.status}
          </span>
        </div>
        <div>{isExpanded ? <FaChevronUp /> : <FaChevronDown />}</div>
      </div>

      {/* Body */}
      {isExpanded && (
        <div className="card-body text-primary">
          {fieldKeys.length === 0 ? (
            <p>No changes requested.</p>
          ) : (
            fieldKeys.map((key) => {
              const oldVal = safeValue(item.original_data[key]);
              const newVal = safeValue(item.requested_data[key]);
              const isImage = imageFields.includes(key);
              const isChecked = selectedFields.includes(key);

              return (
                <div
                  key={key}
                  className="border rounded p-2 mb-2 d-flex flex-column flex-md-row align-items-center justify-content-between gap-3"
                >
                  {/* Field Name */}
                  <div className="flex-grow-1">
                    <strong className="text-capitalize">
                      {key.replace(/_/g, " ")}
                    </strong>
                  </div>

                  {/* Old / New Values */}
                  <div className="flex-grow-1 d-flex align-items-center gap-3">
                    {/* OLD value */}
                    <div className="text-center">
                      <small className="text-muted d-block">Old</small>

                      {isImage ? (
                        isValidImage(oldVal) ? (
                          <img
                            src={oldVal}
                            alt="old"
                            className="rounded border d-block"
                            style={{
                              width: "50px",
                              height: "50px",
                              objectFit: "cover",
                            }}
                          />
                        ) : (
                          <div className="text-muted">No Image</div>
                        )
                      ) : (
                        <div className="p-1 border rounded">
                          {oldVal || "—"}
                        </div>
                      )}
                    </div>

                    <div className="fw-bold mx-2">→</div>

                    {/* NEW value */}
                    <div className="text-center">
                      <small className="text-muted d-block">New</small>

                      {isImage ? (
                        isValidImage(newVal) ? (
                          <img
                            src={newVal}
                            alt="new"
                            className="rounded border d-block"
                            style={{
                              width: "50px",
                              height: "50px",
                              objectFit: "cover",
                            }}
                          />
                        ) : (
                          <div className="text-muted">No Image</div>
                        )
                      ) : (
                        <div className="p-1 border rounded">
                          {newVal || "—"}
                        </div>
                      )}
                    </div>
                  </div>

                  {/* Checkbox - only if pending */}
                  {isPending && (
                    <div className="d-flex align-items-center">
                      <label className="form-check-label d-flex align-items-center gap-1">
                        <input
                          type="checkbox"
                          className="form-check-input"
                          checked={isChecked}
                          onChange={() => toggleField(item.id, key)}
                        />
                        Select
                      </label>
                    </div>
                  )}
                </div>
              );
            })
          )}

          {/* Comment */}
          <div className="mb-3 mt-2">
            <label className="form-label">Comment:</label>
            {isPending ? (
              <input
                type="text"
                className="form-control"
                value={comment}
                onChange={(e) => setComment(e.target.value)}
                placeholder="Enter comment (optional)"
              />
            ) : (
              <div className="p-2 border rounded bg-light">
                {item.review_comment || "—"}
              </div>
            )}
          </div>
          {/* Actions - only if pending */}
          {isPending && (
            <div className="d-flex gap-2 mt-2">
              <Button
                type="submit"
                variant="success"
                className="flex-1 d-flex align-items-center justify-content-center gap-2"
                onClick={() => onApprove(comment)}
              >
                <FaCheckCircle /> Approve
              </Button>
              <Button
                type="submit"
                variant="danger"
                className="flex-1 d-flex align-items-center justify-content-center gap-2"
                onClick={() => onReject(comment)}
              >
                <FaTimesCircle /> Reject
              </Button>
            </div>
          )}
        </div>
      )}
    </div>
  );
};
export default React.memo(ParentRequestCard);
